<template>
  <v-container class="ma-0 pa-0" style="overflow: hidden;">
    <v-card class="pa-0 ma-0" align-items="center">
      <v-row justify="center" align="center" class="ma-1">
        <v-spacer></v-spacer>
        <span class="subtitle">
          <b>{{ RAPO_Action }}</b>
        </span>
        <v-spacer></v-spacer>
        <v-btn color="error" text fab small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-divider></v-divider>
      <v-form ref="RAPO_Form" lazy-validation class="pa-3">
        <v-select class="pa-2" hide-details :items="RAPO_Actions" v-model="RAPO_Action" label="Операция" dense></v-select>
        <v-text-field :rules="validate_RAPO_Amount" class="pa-2 pb-0 centered-input" v-model.number="RAPO_Amount" name="RAPO" type="number" outlined dense label="Сума" required></v-text-field>
        <v-text-field v-if="fp.isNew" class="pa-2 pt-0" v-model="RAPO_Text" name="RAPO" type="string" hide-details outlined dense label="Основание" required></v-text-field>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="RAPO">
          <v-icon left :color="this.RAPO_Action == 'Въвеждане' ? `success` : `warning`">{{ this.RAPO_Action == "Въвеждане" ? `mdi-cash-plus` : `mdi-cash-minus` }}</v-icon>
          <span>{{ this.RAPO_Action == "Въвеждане" ? `Въведи` : `Изведи` }}</span>
        </v-btn>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import Tremol from "../assets/fp/fp";
import Const from "../constants";

export default {
  data() {
    return {
      RAPO_Action: "Въвеждане",
      RAPO_Actions: ["Въвеждане", "Извеждане"],
      RAPO_Amount: Number(0),
      RAPO_Text: "",
      validate_RAPO_Amount: [v => !!v || "Задължително поле", v => (typeof v != Number && v != 0 && v > 0) || "Моля, въведете вярна сума!"]
    };
  },
  methods: {
    async close() {
      this.fp.exitMode(Const.Modes.MoneyInOut);
    },
    async RAPO() {
      if (this.$refs.RAPO_Form.validate()) {
        try {
          var op1 = await this.fp.ReadOperatorNamePassword(1);
          var amount = this.RAPO_Action == "Въвеждане" ? this.RAPO_Amount : -this.RAPO_Amount;
          await this.fp.executeWithLoader(async () => {
            await this.fp.ReceivedOnAccount_PaidOut(1, op1.Password, Tremol.Enums.OptionPayType.Cash, amount, Tremol.Enums.OptionPrintAvailability.No, this.RAPO_Text);
          }, this.RAPO_Action + " на сума...");
          this.fp.exitMode(Const.Modes.MoneyInOut);
        } catch (ex) {
          this.fp.handleException(ex);
        }
      }
    }
  }
};
</script>